import type { BackdropMode, ViewMode } from './constants';

// All cross-module mutable runtime state lives here. ES module imports are
// read-only live bindings, so anything reassigned from more than one module is
// kept as a property of this single shared object.
export const state = {
  // Dimensions (inches)
  W: 6,
  H: 9,
  S: 1.1,

  // Form sliders (0..1)
  bulgeF: 0.5,
  squareF: 0.5,
  grooveF: 0.6,
  grooveWF: 0.5,
  bowF: 0.35,
  warpF: 0.0,
  reflInt: 0.55,

  // Backdrop
  groundY: -1,
  backdropMode: 'studio' as BackdropMode,
  backdropColor: '#ece7dd',
  bdUniform: false, // flat: merge plane + backdrop into one seamless field

  // Camera / interaction
  rotX: 0.16,
  rotY: 0.62,
  panX: 0,
  panY: 0,
  zoom: 1,
  bookSpin: 0, // turntable: Y rotation of the book
  viewMode: 'turntable' as ViewMode,
  isDragging: false,
  isRight: false,
  prevX: 0,
  prevY: 0,
  autoRot: true,

  // Lighting calibration
  tempK: 5500,
  tint: 0,
  exposure: 1.0,
};
